import React, { forwardRef, ReactNode } from 'react'
import styles from './DropdownElement.module.sass'
import clsx from 'clsx'
import ChevronDownIcon from '../../../../../files/chevron/down.svg'
import { Classes } from '../../../../styles'

interface Props {
    className?: string,
    placeholder?: ReactNode,
    children: ReactNode,
    active: boolean,
    block?: boolean,
    borderless?: boolean,
    onToggle: (active: boolean) => void,
    selected?: any, // eslint-disable-line
    dropdownPlaceholder?: boolean
}

const DropdownElement = forwardRef<HTMLDivElement, Props>((props, ref) => {
    return <div
        ref={ref}
        className={clsx(props.className, Classes.touchTarget, {[Classes.flex]: props.block})}
    >
        <div
            className={clsx(props.className, styles.dropdown, {
                [styles.active]: props.active,
                [styles.borderless]: props.borderless,
            })}
            onClick={() => props.onToggle(!props.active)}
        >
            {
                props.dropdownPlaceholder ?
                    <div className={clsx(styles.content, {[styles.placeholder]: props.selected[0] === null})}>
                        {props.selected[0] !== null ? props.children : props.placeholder}
                    </div> :
                    <div className={clsx(styles.content, {[styles.placeholder]: !props.children})}>
                        {props.children || props.placeholder}
                    </div>
            }

            <ChevronDownIcon className={clsx(styles.icon,{ [Classes.flip]: props.active })}/>
        </div>
    </div>
})

DropdownElement.displayName = 'DropdownElement'

export default DropdownElement